/**
 * Fallback labels for enum keys that no label map covers.
 *
 * Every categorical map in the app (compensation models, fee types, …) is
 * hand-maintained, so a value written by a path the map's author didn't know
 * about — a seed script, an older editor build, a direct SQL insert — used to
 * render as nothing at all. On a comparison surface a silently dropped value is
 * worse than an imperfect one: the reader concludes the org doesn't have it.
 * Humanise the key instead, so the value is always visible even when its label
 * hasn't been authored yet.
 */

const words = (key: string): string[] =>
  String(key ?? "")
    .replace(/[_-]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

/** `cap_based` → "Cap Based". For maps whose labels are Title Case. */
export const humaniseEnumKey = (key: string): string =>
  words(key)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

/** `cap_based` → "Cap based". For maps whose labels are sentence case. */
export const humaniseEnumKeySentence = (key: string): string => {
  const parts = words(key);
  if (!parts.length) return "";
  return [parts[0].charAt(0).toUpperCase() + parts[0].slice(1), ...parts.slice(1)].join(" ");
};
